import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'kt-template-edit',
  templateUrl: './template-behavior.component.html',
  styleUrls: ['./template-behavior.component.scss'],
})
export class TemplateBehaviorComponent implements OnInit {
  behaviorForm: FormGroup;
  templateBehavior;
  editUrlShow = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TemplateBehaviorComponent>,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.templateBehavior = this.data.templateBehavior;
    this.createForm();
  }

  createForm() {
    const freqArray = this.templateBehavior.frequency?.split(' ');
    const frequency = {
      time: freqArray ? freqArray[0] : '',
      type: freqArray ? freqArray[1] : '',
    };
    this.behaviorForm = this.fb.group({
      primary_source_system: [this.templateBehavior.primary_source_system],
      source_description: [this.templateBehavior.source_description],
      frequency_time: [frequency.time, Validators.min(1)],
      frequency_type: [frequency.type],
      task_activation: [this.templateBehavior.task_activation],
      update_condition: [this.templateBehavior.update_condition],
      url_request_ticket: [
        this.templateBehavior.url_request_ticket,
        Validators.pattern(
          'https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_+.~#?&\\/=]*)',
        ),
      ],
    });
  }

  validateUrl() {
    if (this.showExternalLinkIcon()) {
      this.editUrlShow = true;
    }
  }

  showExternalLinkIcon() {
    const url = this.behaviorForm.get('url_request_ticket').value;
    return url && url.length > 0 && !this.isControlHasError('url_request_ticket', 'pattern');
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.behaviorForm.controls[controlName];
    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  openExternalLink() {
    window.open(this.behaviorForm.get('url_request_ticket').value, '_blank');
  }
  save() {
    const controls = this.behaviorForm.controls;
    const behavior = {
      primary_source_system: controls.primary_source_system.value,
      source_description: controls.source_description.value,
      frequency: controls.frequency_time.value + ' ' + controls.frequency_type.value,
      task_activation: controls.task_activation.value,
      api_update: !!controls.update_condition.value,
      update_condition: controls.update_condition.value,
      url_request_ticket: controls.url_request_ticket.value,
    };
    this.dialogRef.close({ behavior });
  }

  close() {
    this.dialogRef.close(null);
  }
}
